import environmentManager from '../environment.manager';
export default {
  /**
     * 设置分享显隐 
     */
  setShareBarShowHide (isShow = false) {
    const share = environmentManager.getEnv();
    console.warn(share, isShow);
    if (isShow) {
      if (share.setShareData) {
        let shareData = share.getShareData();
        share.setShareData(shareData);
      }
    } else {
      if (share.setShareBarHide) {
        share.setShareBarHide();
      }
    }
  },
  /**
   * 设置手机端右滑关闭是否开启
   */
  setupBrowser (isOpen = false) {
    const share = environmentManager.getEnv();
    if (share.setupBrowser) {
      if (isOpen) {
        share.setupBrowser('true', 'true');
      } else {
        share.setupBrowser('false', 'false');
      }
    }
  },
  /**
   * VR带看接通/挂断时逻辑处理
   * @param {Boolean} isOnCall 
   */
  onPhoneCallOnOrOff (isOnCall = false) {
    if (isOnCall) {
      this.setShareBarShowHide(false);
      this.setupBrowser(false);
    } else {
      this.setShareBarShowHide(true);
      this.setupBrowser(true);
    }
  },
};